import { render } from "./subTopicCheck.vue?vue&type=template&id=0a8f9d31&scoped=true"
import script from "./subTopicCheck.vue?vue&type=script&lang=js"
export * from "./subTopicCheck.vue?vue&type=script&lang=js"

import "./subTopicCheck.vue?vue&type=style&index=0&id=0a8f9d31&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8f9d31"]])

export default __exports__